import React, { useEffect } from 'react';
import { HeroSection } from './components/sections/HeroSection';
import { StatsSection } from './components/sections/StatsSection';
import { GallerySection } from './components/sections/GallerySection';
import { VolumesSection } from './components/sections/VolumesSection';
import { BonusesSection } from './components/sections/BonusesSection';
import { OfferSection } from './components/sections/OfferSection';
import { ComparisonSection } from './components/sections/ComparisonSection';
import { FaqSection } from './components/sections/FaqSection';
import { FinalCtaSection } from './components/sections/FinalCtaSection';
import { SiteFooter } from './components/SiteFooter';
import { PurchasePopup } from './components/PurchasePopup';
import { initMetaPixel, PIXEL_ID } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-zinc-950 text-zinc-50 antialiased" data-id="element-0" data-mp="23vuoyeelqyvo">
      <noscript data-id="element-1" data-mp="3ijxoypkvdyjd">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="3ikh98cxzsz0k" />
      </noscript>
      <HeroSection data-id="element-3" data-mp="3rc9du70c5dx8" />
      <main data-id="element-4" data-mp="3rbrayrj641gc">
        <StatsSection data-id="element-5" data-mp="3rbzpsoyupgu6" />
        <GallerySection data-id="element-6" data-mp="3rcsw5otwe4bs" />
        <VolumesSection data-id="element-7" data-mp="3reltgdimfc74" />
        <BonusesSection data-id="element-8" data-mp="5opiv1o0k3w" />
        <OfferSection data-id="element-9" data-mp="4wx1t3d72hu" />
        <ComparisonSection data-id="element-10" data-mp="56nfhsbnbo2" />
        <FaqSection data-id="element-11" data-mp="2zl39tfhhuw2o" />
        <FinalCtaSection data-id="element-12" data-mp="2zllen0i82im7" />
      </main>
      <SiteFooter data-id="element-13" data-mp="2zmo4d53t6f0j" />
      <PurchasePopup data-id="element-14" data-mp="2zn6biws0edn8" />
    </div>;
}